import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "../api/axios";
import './styles/LoginSignup.css';
import { Helmet } from "react-helmet-async";
import NotFoundPage from "./NotFoundPage";

const ManualPasswordReset = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("token"); // or "manual_reset", depending on your link
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [valid, setValid] = useState(false);
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  useEffect(() => {
    if (!code) {
      setError("Invalid or missing reset code.");
      setLoading(false);
      setValid(false);
      return;
    }
    // Verify the manual reset code (hit your backend)
    const verify = async () => {
      try {
        const res = await axios.post("/api/auth/verify-manual-reset", { token: code });
        if (res.data.valid) setValid(true);
        else setError(res.data.error || "Invalid or expired reset link.");
      } catch {
        setError("Invalid or expired reset link.");
      }
      setLoading(false);
    };
    verify();
  }, [code]);

  const handleChange = e => setFormData(f => ({
    ...f,
    [e.target.name]: e.target.value,
  }));

  const handleSubmit = async e => {
    e.preventDefault();
    setError("");
    if (formData.password.length < 7) {
      setError("Password must be at least 7 characters.");
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    setSubmitting(true);
    try {
      await axios.post("/api/auth/complete-manual-reset", {
        token: code,
        password: formData.password,
      });
      navigate("/login?reset=1");
    } catch (err) {
      setError(err.response?.data?.error || "Password reset failed.");
    }
    setSubmitting(false);
  };

  if (loading) return <div className="auth-container"><p>Verifying reset link...</p></div>;
  if (!code || !valid) return <NotFoundPage />;

  return (
    <>
      <Helmet>
        <title>Password Reset - Website Name</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="auth-page-wrapper">
        <div className="auth-container">
          <h2>Reset Your Password</h2>
          <p className="info" style={{ margin: "12px 0" }}>
            This page allows you to securely reset your account password. 
            Please choose a strong, unique password you haven't used before.
          </p>
          {error && <p className="error">{error}</p>}
          <form onSubmit={handleSubmit}>
            <input
              name="password"
              type="password"
              placeholder="New Password"
              value={formData.password}
              onChange={handleChange}
              autoComplete="new-password"
              required
            />
            <input
              name="confirmPassword"
              type="password"
              placeholder="Confirm New Password"
              value={formData.confirmPassword}
              onChange={handleChange}
              autoComplete="new-password"
              required
            />
            <button type="submit" disabled={submitting}>
              {submitting ? "Resetting..." : "Reset Password"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default ManualPasswordReset;